import React, { useState, useMemo } from 'react';
import { api, apis, getIn18Text, inWindow } from 'api';
import classnames from 'classnames';
import SiriusTable from '@lingxi-common-component/sirius-ui/Table';
import { Tooltip } from 'antd';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
const wordSeparator = inWindow() && window.systemLang === 'en' ? ' ' : '';
const systemApi = api.getSystemApi();
const productApi = api.requireLogicalApi(apis.productAuthApiImpl);
const MailReadList = ({ item, readList = [], isLoadingReadList = false, forbid = false }) => {
    const [readListVisible, setReadListVisible] = useState(false);
    let { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const hasReadList = useMemo(() => {
        const isRead = item.status && item.status === 'read' ? true : false;
        if (item.result && item.result === 109 && isRead) {
            if (productVersionId === 'sirius') {
                return true;
            }
            else if (productVersionId == 'ultimate' && (readList === null || readList === void 0 ? void 0 : readList.length)) {
                const list = readList.filter(item => item.inner);
                return list && list.length > 0;
            }
        }
        return false;
    }, [item, productVersionId, readList]);
    const showReadList = useMemo(() => {
        if (productVersionId === 'sirius') {
            return readList;
        }
        if (productVersionId === 'ultimate') {
            return readList.filter(item => item.inner);
        }
        return [];
    }, [readList, productVersionId]);
    const tableColumsLx = [
        {
            title: getIn18Text('LOCAL_TIME'),
            dataIndex: 'readTime',
            key: 'readTime',
            render: (text) => text || '--',
        },
        {
            title: getIn18Text('READER_LOCAL_TIME'),
            dataIndex: 'localReadTime',
            key: 'localReadTime',
            render: (text) => text || '--',
        },
    ];
    const tableColumsWaimao = [
        {
            title: getIn18Text('LOCAL_TIME'),
            dataIndex: 'readTime',
            key: 'readTime',
            render: (text) => text || '--',
        },
        {
            title: getIn18Text('READ_CITY'),
            dataIndex: 'location',
            key: 'location',
            ellipsis: true,
            render(value) {
                return !!value ? (React.createElement(Tooltip, { title: value },
                    React.createElement("div", { className: "u-item-readlist-item-location" }, value))) : ('--');
            },
        },
        {
            title: getIn18Text('READER_LOCAL_TIME'),
            dataIndex: 'localReadTime',
            key: 'localReadTime',
            render: (text) => text || '--',
        },
        {
            title: getIn18Text('IP_ADDRESS'),
            dataIndex: 'clientIp',
            key: 'clientIp',
            render: (text) => text || '--',
        },
    ];
    const tableColums = useMemo(() => {
        if (readListVisible) {
            if (process.env.BUILD_ISEDM) {
                return tableColumsWaimao;
            }
            else {
                try {
                    const orgId = systemApi.getCurrentCompanyId();
                    const whiteList = JSON.parse(productApi.getABSwitchSync('mail_show_trace_city'));
                    if (orgId && Array.isArray(whiteList) && whiteList.includes(orgId)) {
                        tableColumsLx.push({
                            title: getIn18Text('READ_CITY'),
                            dataIndex: 'location',
                            key: 'location',
                            ellipsis: true,
                            render(value) {
                                return !!value ? (React.createElement(Tooltip, { title: value },
                                    React.createElement("div", { className: "u-item-readlist-item-location" }, value))) : ('--');
                            },
                        });
                    }
                }
                catch (error) {
                    console.log(error);
                    return tableColumsLx;
                }
                return tableColumsLx;
            }
        }
        else {
            return [];
        }
    }, [readListVisible]);
    const handleStatusClicked = () => {
        if (!hasReadList || forbid) {
            return;
        }
        setReadListVisible(!readListVisible);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "u-item-read-list-status-wrapper", onClick: handleStatusClicked },
            React.createElement("div", { className: classnames(['u-item-status', item.status == 'suc' || (item === null || item === void 0 ? void 0 : item.rclResult) === 9 ? 'u-suc' : '']), style: { color: item.color, userSelect: hasReadList ? 'none' : 'auto' } }, item.status == 'suc'
                ? getIn18Text('CHEHUICHENGGONG') + wordSeparator
                : item.status == 'fail' || (item === null || item === void 0 ? void 0 : item.rclResult) === 9
                    ? getIn18Text('CHEHUISHIBAI') + wordSeparator
                    : item.text),
            hasReadList && !forbid && (React.createElement("div", { className: 'u-item-read-down-icon' + (readListVisible ? ' u-item-read-down-icon-trans' : '') },
                React.createElement("svg", { width: "8", height: "8", viewBox: "0 0 8 8", fill: "none" },
                    React.createElement("path", { d: "M4.39043 6.51196L7.35012 2.81235C7.61203 2.48497 7.37894 2 6.95969 2L1.04031 2C0.621061 2 0.387974 2.48496 0.64988 2.81235L3.60957 6.51196C3.80973 6.76216 4.19027 6.76216 4.39043 6.51196Z", fill: "#8D92A1" }))))),
        hasReadList && readListVisible && !forbid && (React.createElement("div", { className: "u-item-readlist-table-wrapper" },
            React.createElement(SiriusTable, { bordered: true, columns: tableColums, loading: isLoadingReadList, scroll: { y: 164 }, dataSource: showReadList, pagination: false })))));
};
export default MailReadList;
